export const PrerequisiteTarget = {
  items: [
    {
      Name: 'Target B',
      Description: 'Descriptions goes in this column here',
      ModifiedDate: '2024-10-10'
    },
    {
      Name: 'Target C',
      Description: 'Descriptions goes in this column here',
      ModifiedDate: '2024-10-10'
    },
    {
      Name: 'Target D',
      Description: 'Descriptions goes in this column here',
      ModifiedDate: '2024-10-10'
    }
  ]
};
